import http from '../services/http';

export const apiRegisterDevice = async (deviceData) => {
    try {
        const response = await http.post('/api/device/register', {
            device_id: deviceData.device_id,
            device_type: deviceData.device_type || 3,
            fcm_token: deviceData.fcm_token
        });
        return response;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};